import { blue, green } from "./colors/index.js";
const illustration = (mode)=>'light' === mode ? {
        blue1: blue["100"],
        blue2: blue["200"],
        green1: green["100"],
        green2: green["300"]
    } : {
        blue1: blue["800"],
        blue2: blue["700"],
        green1: green["800"],
        green2: green["600"]
    };
export { illustration };

//# sourceMappingURL=illustration.js.map